import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInactiveStudentsRequest } from "../../../modules/admin-modules/students/Actions";
import StudentRosterTable from "./studentRosterTable";

const InactiveStudentsTable = ({
  setAdd,
  setSelectedData,
  searchTerm,
  inactivePeriod,
  activityFilters,
}) => {
  const dispatch = useDispatch();
  const inactiveStudents = useSelector((state) => state.students.inactiveStudents);
  const isLoading = useSelector((state) => state.students.isLoading);
  const count = useSelector((state) => state.students.count);

  const [size, setPerPage] = useState(50);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(
    () => (Array.isArray(inactiveStudents) ? inactiveStudents : []),
    [inactiveStudents]
  );

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm, inactivePeriod, activityFilters]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      const flag = inactivePeriod === "oneWeek" ? 1 : undefined;
      dispatch(
        getInactiveStudentsRequest(pageNumber + 1, searchTerm || "", flag, activityFilters)
      );
    }, 200);
    return () => clearTimeout(timeId);
  }, [pageNumber, searchTerm, inactivePeriod, activityFilters, dispatch]);

  return (
    <StudentRosterTable
      setAdd={setAdd}
      setSelectedData={setSelectedData}
      list={list}
      isLoading={isLoading}
      count={count}
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      size={size}
      setPerPage={setPerPage}
    />
  );
};

export default InactiveStudentsTable;
